let MAP;
let HOTEL_PIN;
let iconDefault;
let iconHover;
let CONFIG_MAP = {};

document.addEventListener('DOMContentLoaded', () => {  
    if ( document.querySelector('section#attractions-module') ){
        console.log('DOMContentLoaded and attractions-module found');
        function activeAttractionOnList(marker){
            let attraction_active = document.querySelector(`article[data-attraction]:not(.no-active)`),
                attraction_to_active = document.querySelector(`article[data-attraction][data-name="${marker.title}"]`);

            attraction_active.classList.add('no-active');
            attraction_to_active.classList.remove('no-active');
            matchAttractionWithMarkers(attraction_to_active);
        }

        function updateAttractionFromArrow(arrow){
            let attractionActive = document.querySelector(`article[data-attraction]:not(.no-active)`),
                firstAttraction = document.querySelector(`article[data-attraction]:first-of-type`),
                lastAttraction = document.querySelector(`article[data-attraction]:last-of-type`),
                newAttractionActive = null;
                
            if( arrow.classList.contains('js-prevAttrArrow') ){
                if( attractionActive.previousElementSibling == null ){
                    attractionActive.classList.add('no-active');
                    newAttractionActive = lastAttraction;
                    newAttractionActive.classList.remove('no-active');
                    matchAttractionWithMarkers(newAttractionActive);
                }else{
                    attractionActive.classList.add('no-active');
                    newAttractionActive = attractionActive.previousElementSibling;
                    newAttractionActive.classList.remove('no-active');
                    matchAttractionWithMarkers(newAttractionActive);
                }
            }else{
                if( attractionActive.nextElementSibling == null ){
                    attractionActive.classList.add('no-active');
                    newAttractionActive = firstAttraction;
                    newAttractionActive.classList.remove('no-active');
                    matchAttractionWithMarkers(newAttractionActive);
                }else{
                    attractionActive.classList.add('no-active');
                    newAttractionActive = attractionActive.nextElementSibling;
                    newAttractionActive.classList.remove('no-active');
                    matchAttractionWithMarkers(newAttractionActive);
                }
            }
        }

        function initMapTypeControl(map) {
			if (document.querySelector('.attractions-map__satellite') !== null) {
				document.querySelector('.attractions-map__satellite').onclick = function () {
					document.querySelector('.attractions-map__map').classList.remove('active');
					this.classList.remove('active');
					this.classList.add('active');
					map.setMapTypeId('hybrid');
				};
			}

			if (document.querySelector('.attractions-map__map') !== null) {
				document.querySelector('.attractions-map__map').onclick = function () {
					document.querySelector('.attractions-map__satellite').classList.remove('active');
					this.classList.remove('active');
					this.classList.add('active');
					map.setMapTypeId('roadmap');
				};
			}
		}

        function loadMarker(pin, map_selector, icon) {
			//writes the marker to the map. pass a javascript object with the markers longitude latitude id and name so that the code can keep track of all the markers.

			let { id, name, lat, long } = pin;

			var image = {
				url: icon,
				// This marker is 20 pixels wide by 32 pixels high.
				size: new google.maps.Size(30, 45),
				// The origin for this image is (0, 0).
				origin: new google.maps.Point(0, 0),
				// The anchor for this image is the base of the flagpole at (0, 32).
				anchor: new google.maps.Point(0, 45),
			};

			// create new marker
			let marker = new google.maps.Marker({
				id: id,
				map: map_selector,
				title: name,
				icon: icon,
				zIndex: 1,
				position: new google.maps.LatLng(lat, long),
			});

            marker.addListener('click', (event) => activeAttractionOnList(marker));

            marker.addListener('mouseover', function () {
				marker.setIcon(iconHover);
			});

			marker.addListener('mouseout', function () {
				marker.setIcon(icon);
			});

			return marker;
		}

        function matchAttractionWithMarkers( articleActiveOnList ) {
            let nameAttractionActive = typeof articleActiveOnList == 'string' ? articleActiveOnList : articleActiveOnList.dataset.name;
        
            GoogleMapsMarkers.forEach((itemMarker) => {
                if( itemMarker.title == nameAttractionActive ){
                    itemMarker.setIcon(iconHover);
                    itemMarker.addListener('mouseout', function () {
                        itemMarker.setIcon(iconHover);
                    })
                    if(typeof articleActiveOnList != 'string'){
                        var latLng = itemMarker.getPosition();
                        MAP.panTo(latLng);
                    }
                }else{
                    itemMarker.setIcon(iconDefault);
                }
            });
        }
        
        function getAttractionMarkUp(attraction, count, lengthAttractions) {
            const {
                id,
                name,
                thumb,
                description,
                address,
                distance,
                walking,
                biking,
                driving,
                subway,
                label_learn_more,
                label_minutes_walking,
                label_minutes_biking,
                url,
                label_minutes_driving,
                label_minutes_subway,
                label_miles,
                label_ft,
                label_from,
                label_visit_website,
            } = attraction;
        
            let imageAttraction = `${thumb[0].full_size}`;
        
            let image_markup = '';
            if (imageAttraction) image_markup = `<img src="${imageAttraction}" alt="${thumb[0].alt !== 'null' ? thumb[0].alt : 'placeholder image'}" ${thumb[0].alt == null ? 'aria-hidden="true"' : ''}>`;
        
            let iconMiles =
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20"><path id="Path_20180" data-name="Path 20180" d="M1.276,11.569l.04.054c.049.069.1.135.151.208l5.791,7.8a.943.943,0,0,0,1.259.211.879.879,0,0,0,.225-.211l5.777-7.8c.056-.073.109-.144.162-.208l.036-.05A7.231,7.231,0,0,0,12.341,1.2,8.322,8.322,0,0,0,1.281,3.432a7.117,7.117,0,0,0,0,8.147ZM8,4.383A3.235,3.235,0,0,1,11.334,7.51,3.235,3.235,0,0,1,8,10.637,3.235,3.235,0,0,1,4.667,7.51,3.235,3.235,0,0,1,8,4.383" transform="translate(0 0)" fill="#a39161"/></svg>';
                
            let milesInfo = `<span>${distance} ${distance > 100 ? label_ft : (distance == 1 ? "Mile" : label_miles)}</span>`;

            let iconWalking =
                '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" viewBox="0 0 13 24"><g id="Group_2571" data-name="Group 2571" transform="translate(-526 -1182)"><path id="Path_20181" data-name="Path 20181" d="M20,4.212a2.106,2.106,0,1,0-2.106-2.106A2.109,2.109,0,0,0,20,4.212" transform="translate(513.123 1182)" fill="#a39161"/><path id="Path_20182" data-name="Path 20182" d="M12.946,24.993a1.09,1.09,0,0,0-.542-.633l-2.11-1.073-2.013-3.9-.019-.035a1.957,1.957,0,0,0-1.735-1.03,1.979,1.979,0,0,0-1.365.541.952.952,0,0,0-.095.081l-3.2,3.031a1.061,1.061,0,0,0-.295.484L.688,25.6a1.074,1.074,0,0,0,.773,1.322,1.088,1.088,0,0,0,.295.038,1.1,1.1,0,0,0,1.065-.789l.812-2.866.942-.892v4.131L3.5,31.708.307,35.3a1.184,1.184,0,0,0-.3.887,1.2,1.2,0,0,0,.431.835A1.277,1.277,0,0,0,2.2,36.894l3.413-3.831a1.2,1.2,0,0,0,.281-.557l.464-2.233,3.483,6.394a1.255,1.255,0,0,0,1.109.649,1.268,1.268,0,0,0,.587-.143,1.2,1.2,0,0,0,.52-1.649L8.482,28.961V24.568a1.09,1.09,0,0,0,.473.465l2.427,1.233a1.12,1.12,0,0,0,.511.122,1.108,1.108,0,0,0,.981-.579,1.041,1.041,0,0,0,.075-.819Z" transform="translate(526 1168.684)" fill="#a39161"/></g></svg>';
            let walkingInfo = `<span>${walking.replace('mins', '').replace('min', '')} ${label_minutes_walking}</span>`;
        
            let iconBiking =
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#A39161"><path d="M18.984 20.484c1.922 0 3.516-1.547 3.516-3.469s-1.594-3.516-3.516-3.516-3.469 1.594-3.469 3.516 1.547 3.469 3.469 3.469zM18.984 12c2.813 0 5.016 2.203 5.016 5.016s-2.203 4.969-5.016 4.969-4.969-2.156-4.969-4.969 2.156-5.016 4.969-5.016zM10.781 10.5l2.203 2.297v6.188h-1.969v-4.969l-3.234-2.813c-0.422-0.281-0.563-0.797-0.563-1.406 0-0.516 0.141-0.984 0.563-1.406l2.813-2.813c0.281-0.422 0.797-0.563 1.406-0.563s1.078 0.141 1.594 0.563l1.922 1.922c0.891 0.891 2.063 1.5 3.563 1.5v2.016c-2.109 0-3.75-0.797-5.063-2.109l-0.797-0.797zM5.016 20.484c1.922 0 3.469-1.547 3.469-3.469s-1.547-3.516-3.469-3.516-3.516 1.594-3.516 3.516 1.594 3.469 3.516 3.469zM5.016 12c2.813 0 4.969 2.203 4.969 5.016s-2.156 4.969-4.969 4.969-5.016-2.156-5.016-4.969 2.203-5.016 5.016-5.016zM15.516 5.484c-1.078 0-2.016-0.891-2.016-1.969s0.938-2.016 2.016-2.016 1.969 0.938 1.969 2.016-0.891 1.969-1.969 1.969z"/></svg>';
            let bikingInfo = `<span>${biking.replace('mins', '')} ${label_minutes_biking}</span>`;
        
            let iconDriving =
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#A39161"><path d="M5.016 11.016h13.969l-1.5-4.5h-10.969zM17.484 15.984c0.844 0 1.5-0.656 1.5-1.5s-0.656-1.5-1.5-1.5-1.5 0.656-1.5 1.5 0.656 1.5 1.5 1.5zM6.516 15.984c0.844 0 1.5-0.656 1.5-1.5s-0.656-1.5-1.5-1.5-1.5 0.656-1.5 1.5 0.656 1.5 1.5 1.5zM18.938 6l2.063 6v8.016c0 0.563-0.422 0.984-0.984 0.984h-1.031c-0.563 0-0.984-0.422-0.984-0.984v-1.031h-12v1.031c0 0.563-0.422 0.984-0.984 0.984h-1.031c-0.563 0-0.984-0.422-0.984-0.984v-8.016l2.063-6c0.188-0.609 0.797-0.984 1.453-0.984h10.969c0.656 0 1.266 0.375 1.453 0.984z"/></svg>';
            let drivingInfo = `<span>${driving.replace('mins', '').replace('min', '')} ${label_minutes_driving}</span>`;
        
            let iconSubway =
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 400 400" fill="#A39161" xml:space="preserve"><g><g><path d="M202.667,0C108.373,0,32,10.667,32,85.333V288c0,41.28,33.493,74.667,74.667,74.667l-32,32v10.667h256v-10.667l-32-32 c41.28,0,74.667-33.387,74.667-74.667V85.333C373.333,10.667,296.96,0,202.667,0z M106.667,320c-17.707,0-32-14.293-32-32 s14.293-32,32-32s32,14.293,32,32S124.373,320,106.667,320z M181.333,192H74.667V85.333h106.667V192z M298.667,320 c-17.707,0-32-14.293-32-32s14.293-32,32-32s32,14.293,32,32S316.373,320,298.667,320z M330.667,192H224V85.333h106.667V192z"></path></g></g></svg>';
            let subwayInfo = `<span>${subway.replace('mins', '').replace('min', '')} ${label_minutes_subway}</span>`;
            let link = url.indexOf('http') < 0 ? site_url + url : url;

            let iconPrevArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="15.24" height="16.434" viewBox="0 0 15.24 16.434"><path id="Left" d="M47.4,0,46.365,1.208S50.7,5.558,52.557,7.25C46.039,7.183,40,7.25,40,7.25V8.7s6.043-.053,12.557,0c-1.858,1.933-6.192,6.283-6.192,6.283l1.032,1.45L55.24,7.975Z" transform="translate(55.24 16.434) rotate(180)" fill="#fff"/></svg>`,
                iconNextArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="15.24" height="16.434" viewBox="0 0 15.24 16.434"><path id="Right" d="M47.4,0,46.365,1.208S50.7,5.558,52.557,7.25C46.039,7.183,40,7.25,40,7.25V8.7s6.043-.053,12.557,0c-1.858,1.933-6.192,6.283-6.192,6.283l1.032,1.45L55.24,7.975Z" transform="translate(-40)" fill="#fff"/></svg>`;
        
            let markup_arrows = window.innerWidth > 640 ? `<asidde class="attractions_arrow"><button class="attractions_prevArrow js-prevAttrArrow" aria-label="Previous slide">${iconPrevArrow}</button><button class="attractions_nextArrow js-nextAttrArrow" aria-label="Next slide">${iconNextArrow}</button></asidde>` : '';

            let markup = `<article data-attraction="${id}" class="eachAttraction swiper-slide ${count > 0 ? 'no-active' : ''}" data-index="${count}" data-name="${name}">
                            <div class="eachAttraction_wrapper">
                                <figure class="eachAttraction_image">
                                    ${image_markup}
                                </figure>
                                <div class="eachAttraction_info">
                                    ${ lengthAttractions > 1 ? markup_arrows : '' }
                                    <h2 class="eachAttraction_title">${name}</h2>
                                    <div class="eachAttraction_addres">${address}</div>
                                    <div class="eachAttraction_description">${description}</div>
                                
                                    ${distance.length > 0 || walking.length > 0 || biking.length > 0 || driving.length > 0 || subway.length > 0 ? '<ul class="additional-info">' : ''}
                                        ${distance.length > 0 ? '<li>' + iconMiles + ' ' + milesInfo + '</li>' : ''}
                                        ${walking.length > 0 ? '<li>' + iconWalking + ' ' + walkingInfo + '</li>' : ''}
                                        ${biking.length > 0 ? '<li>' + iconBiking + ' ' + bikingInfo + '</li>' : ''}
                                        ${driving.length > 0 ? '<li>' + iconDriving + ' ' + drivingInfo + '</li>' : ''}
                                        ${subway.length > 0 ? '<li>' + iconSubway + ' ' + subwayInfo + '</li>' : ''}
                                    ${distance.length > 0 || walking.length > 0 || biking.length > 0 || driving.length > 0 || subway.length > 0 ? '</ul>' : ''}
                                    ${url && '<a class="pin-website" aria-label="' + label_visit_website + ' of ' + name + '" href="' + link + '" target="_blank">' + label_visit_website + '</a>'}  
                                </div>
                            </div>
                        </article>`;
        
            return markup;
        }
        
        
        function GetAttractionsMarkup(attractions) {
            let markup = ``;
            let count = 0;
            attractions.forEach((attraction) => {(markup += getAttractionMarkUp(attraction, count, (attractions.length))); count++});
        
            ATTRACTIONS_WRAPPER.innerHTML = markup;

            let getAllAttractionList = document.querySelectorAll('article[data-attraction]'),
                arrowsAttractions = document.querySelectorAll(`.attractions_arrow button`);

            arrowsAttractions.forEach( (arrow) => arrow.addEventListener( 'click', () => { updateAttractionFromArrow(arrow) } ) )
        }
        
        function LoadGoogleMaps( config, pins ){
            const InitializeMap = (lat, long, zoom = 13, styles) => {
                //SET POSITION OF MAP
                let PinPosition = new google.maps.LatLng(lat, long); //set longitude and latitude
        
                let styles_temp = isValidJson(styles) ? JSON.parse(styles) : '';
        
                // option for google map object
                let myOptions = {
                    zoom: zoom,
                    center: PinPosition,
                    mapTypeId: 'roadmap',
                    mapTypeControl: false,
                    styles: styles_temp,
                    scrollwheel: false,
                    disableDoubleClickZoom: false,
                    backgroundColor: '#ffffff',
                    panControl: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.RIGHT_CENTER,
                    },
                };
        
                // config initial global for map
                CONFIG_MAP = {
                    zoomInitial: myOptions.zoom,
                    hotel_lat: lat,
                    hotel_long: long,
                    hotel_position: myOptions.center,
                };
        
                // create new map make sure a DIV with id myMap exist on page
                (MAP = new google.maps.Map(GOOGLE_MAPS_WRAPPER, myOptions)),
                    (HOTEL_PIN = {
                        id: 'hotel',
                        map: MAP,
                        title: config.hotel_name,
                        icon: config.hotel_pin.pin,
                        zIndex: 2,
                        position: new google.maps.LatLng(config.hotel_pin.lat, config.hotel_pin.long),
                    });
                // create new marker
                new google.maps.Marker(HOTEL_PIN);
        
                var hotelMaker = new google.maps.Marker(HOTEL_PIN);

       
                hotelMaker.addListener('mouseover', function () {
                    hotelMaker.setIcon("/assets/svg/map-hotel-hover.svg");
                });

                hotelMaker.addListener('mouseout', function () {
                    hotelMaker.setIcon(config.hotel_pin.pin);
                });
         
                pins.forEach((pin) => {
                    let marker = loadMarker(pin, MAP, config.regular_pin.normal);
                    GoogleMapsMarkers.push(marker);
                });
        
                initMapTypeControl(MAP);
        
                return ($GoogleMaps = MAP);
            };
        
            const { lat, long } = config.hotel_pin,
                { map_zoom, snazzy } = config;
        
            InitializeMap(lat, long, map_zoom, snazzy);
        }
        
        function isValidJson(json) {
            try {
                JSON.parse(json);
                return true;
            } catch (e) {
                return false;
            }
        }
        
        function GetAttractions( category ) {
            fetch(`${site_url}ajax/functions.php?operation=FrontendLoadAttractionsCustom&category=${encodeURIComponent(category)}`)
                .then((resp) => resp.json())
                .then((data) => {
                    //POPULATE GOOGLE MAPS & ATTRACTIONS QUAD
                    GetAttractionsMarkup(data.pins);
                    LoadGoogleMaps(data.config, data.pins);
                    matchAttractionWithMarkers(data.pins[0].name);


                    if(window.innerWidth < 600) {
                        document.querySelectorAll('.attractions-swiper').forEach(slider => {
                            const swiper = new Swiper(slider, {
                                slidesPerView: 1,
                                loop: true,
                                speed: 600,
                                effect: "fade",
                                fadeEffect: {
                                    crossFade: true,
                                },
                                navigation: {
                                    nextEl: ".att-next",
                                    prevEl: ".att-prev",
                                },
                            });
                        });
                    };
                    
        
                    return (categoriesData = data);
                    
                });
        }
        
        iconDefault = marker_url;
        iconHover = marker_hover_url;

        let targetMap = document.querySelector('.attractions-map');
        let targetAtractions = document.querySelector('.attractions_left');

        let categoriesData = [],
            GoogleMapsMarkers = [],
            $GoogleMaps = [];

        const   GOOGLE_MAPS_WRAPPER = document.querySelector('#attractions-map'),
                ATTRACTIONS_CONTENT = document.querySelector('#attractions-module'),
                ATTRACTIONS_WRAPPER = document.querySelector('.attractions_content'),
                ATTRACTIONS_FILTER  = document.querySelector(`#attractions-filter`);


        let before_element_filter_clicked = null;
        
        ATTRACTIONS_FILTER.addEventListener( 'click', (e) => {
            if( e.target.nodeName == 'LI' ){
                let element_clicked = e.target;
                if( before_element_filter_clicked ){
                    before_element_filter_clicked.classList.remove('active');
                }
                GetAttractions(element_clicked.dataset.category);
                element_clicked.classList.add('active');
                before_element_filter_clicked = element_clicked;
                if( document.querySelector(`.attractions_labelFilter`) ){
                    document.querySelector(`.attractions_filter`).classList.remove('open');
                    document.querySelector(`.attractions_labelFilter`).textContent = element_clicked.textContent
                }
            }
        });

        ATTRACTIONS_FILTER.querySelector('li').click();

        if( document.querySelector(`.attractions_labelFilter`) ){
            document.querySelector(`.attractions_labelFilter`).addEventListener( 'click', () => {
                document.querySelector(`.attractions_filter`).classList.toggle('open');
            } );   
        }

    }
});